import {MouseEvent, TouchEvent} from "react";

export const isEventWithinInteractiveNode = (
  e: MouseEvent | TouchEvent | KeyboardEvent,
  opts: {ignoreLink?: boolean} = {ignoreLink: false}
) => {
  const {nodeName} = e.target as HTMLElement;
  if (nodeName === "TEXTAREA" || nodeName === "INPUT" || nodeName === "SELECT") return true;
  let current = e.target as HTMLElement | null;
  while (current) {
    if (
      current.nodeName === "BUTTON" ||
      (!opts.ignoreLink && current.nodeName === "A") ||
      current.getAttribute("contenteditable") ||
      current.dataset?.cdxClickable === "true" // for cases like `<div onClick={onClick} data-cdx-clickable>`
    )
      return true;
    current = current.parentElement;
  }
  return false;
};
